import Axios from "axios";
import Cookies from "js-cookie";

export const API_HOST = process.env.REACT_APP_SERVER_HOST;
const axios = Axios.create({
  baseURL: `${API_HOST}`,
  withCredentials: false,
  headers: {
    "Content-Type": "application/json",
  },
});

export const requestInterceptor = (config: any) => {
  const token = Cookies.get("access_token");
  if (token && !config.headers["X-Skip-Auth"]) {
    config.headers["Authorization"] = "Bearer " + token;
  }
  delete config.headers["X-Skip-Auth"];
  return config;
};

export const requestErrorInterceptor = (error: any) => {
  return Promise.reject(error instanceof Error ? error : new Error(String(error)));
};

axios.interceptors.request.use(requestInterceptor, requestErrorInterceptor);

export default axios;
